import React from 'react';
import { useNavigate } from 'react-router-dom';

const FooterCol = ({ navigation, index, handleNavSelector }) => {
  const navigate = useNavigate();
  return (
    <ul className="col-md-2  list-unstyled pt-md-5 py-0">
      <li className="py-2"><a className=" secondary-text  footer-title" >{navigation?.nav_name}</a></li>
      <li onClick={() => handleNavSelector( index ,navigation?.drop_nav1)} className=" footer-link"><a className="text-decoration-none primary-text " href={navigation?.drop_nav1_link}>{navigation?.drop_nav1}</a></li>
      <li onClick={() => handleNavSelector( index ,navigation?.drop_nav2)} className=" footer-link"><a className="text-decoration-none primary-text " href={navigation?.drop_nav2_link}>{navigation?.drop_nav2}</a></li>
      <li onClick={() => handleNavSelector( index ,navigation?.drop_nav3)} className=" footer-link"><a className="text-decoration-none primary-text " href={navigation?.drop_nav3_link}>{navigation?.drop_nav3}</a></li>
      <li onClick={() => handleNavSelector( index ,navigation?.drop_nav4)} className=" footer-link"><a className="text-decoration-none primary-text " href={navigation?.drop_nav4_link}>{navigation?.drop_nav4}</a></li>
      <li onClick={() => handleNavSelector( index ,navigation?.drop_nav5)} className=" footer-link"><a className="text-decoration-none primary-text " href={navigation?.drop_nav5_link}>{navigation?.drop_nav5}</a></li>
      <li onClick={() => handleNavSelector( index ,navigation?.drop_nav6)} className=" footer-link"><a className="text-decoration-none primary-text " href={navigation?.drop_nav6_link}>{navigation?.drop_nav6}</a></li>


    </ul>
  );
};

export default FooterCol;